// Stok kartı (Yeni Stok Ekle / Düzenle) kullanım rehberi. Metinler 'accounting' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'stock.addModal.guide';

export const addInventoryItemGuide = (t: TFunction): GuideContent => ({
  layout: 'card',
  title: t(`${G}.title`, 'Stok kartı nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Kart tek ekrandır: üstte ürünü tanıtan bilgiler, solda bölümler, sağda canlı fiyat özeti. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    strip: t(`${G}.regions.strip`, 'Kimlik şeridi'),
    summary: t(`${G}.regions.summary`, 'Canlı özet'),
  },
  navItems: [
    t('stock.addModal.layout.sections.general', 'Genel'),
    t('stock.addModal.layout.sections.price', 'Fiyat ve vergi'),
    t('stock.addModal.layout.sections.stock', 'Stok ve depo'),
    t('stock.addModal.layout.sections.production', 'Üretim ve lot'),
    t('stock.addModal.layout.sections.features', 'Özellikler ve varyant'),
    t('stock.addModal.layout.sections.other', 'Diğer'),
  ],
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Ürün mü, hizmet mi?'),
      text: t(`${G}.s1.text`, 'Başlıktaki seçimle kart tipini belirleyin. Hizmette stok, depo ve üretim bölümleri gizlenir. Düzenlemede tip değiştirilemez.'),
    },
    {
      region: 'strip',
      title: t(`${G}.s2.title`, '2. Ürünü tanıtın'),
      text: t(`${G}.s2.text`, 'Ad zorunludur. Stok kodu ve barkod boş bırakılırsa otomatik verilir. Birim ve kategoriyi buradan seçin; listede olmayan kategoriyi yanındaki + ile eklersiniz.'),
      tips: [
        t(`${G}.s2.tip1`, 'Barkod başka bir üründe kayıtlıysa hemen uyarılırsınız.'),
        t(`${G}.s2.tip2`, 'Görsel kutusuna tıklayarak görsel ekleyebilirsiniz.'),
      ],
    },
    {
      region: 'nav',
      title: t(`${G}.s3.title`, '3. Bölümler arasında gezin'),
      text: t(`${G}.s3.text`, 'Soldaki bölümler kartın geri kalanını gruplar. Kırmızı nokta, o bölümde eksik zorunlu alan olduğunu gösterir. Telefonda bölümler üstte sekme olarak görünür.'),
    },
    {
      region: 'content',
      title: t(`${G}.s4.title`, '4. Fiyat ve vergiyi girin'),
      text: t(`${G}.s4.text`, 'Önce KDV oranını ve fiyatların KDV dahil mi hariç mi olduğunu seçin, sonra satış (zorunlu) ve alış fiyatını girin.'),
    },
    {
      region: 'content',
      title: t(`${G}.s5.title`, '5. Stok, üretim ve özellikler'),
      text: t(`${G}.s5.text`, 'İhtiyacınız olan bölümleri doldurun; hepsi isteğe bağlıdır.'),
      tips: [
        t(`${G}.s5.tip1`, 'Stok ve depo: açılış stoğu girerseniz depo seçin. Alternatif birimler (koli, paket) burada.'),
        t(`${G}.s5.tip2`, 'Üretim ve lot: üretim modülü açıksa satışta ürünün mü reçetenin mi düşüleceğini seçin.'),
        t(`${G}.s5.tip3`, 'Özellikler ve varyant: renk, beden gibi özellikleri ve varyantları tanımlayın.'),
      ],
    },
    {
      region: 'summary',
      title: t(`${G}.s6.title`, '6. Özeti kontrol edin'),
      text: t(`${G}.s6.text`, 'Sağdaki özet KDV dahil/hariç fiyatı ve kâr marjını anında hesaplar. Eksik bir alana tıklarsanız ilgili bölüme gidersiniz.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s7.title`, '7. Kaydedin'),
      text: t(`${G}.s7.text`, 'Alt çubuk eksik alan sayısını gösterir. "Kaydet ve Yeni Ekle" kartı kaydedip boş bir kart açar. Sağ üstteki (i) düğmesi bu rehberi her zaman yeniden açar.'),
    },
  ],
});
